import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSplitscreenRight = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 48,
	viewBox: "0 -960 960 960",
	width: 48,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M570-120q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h210q24 0 42 18t18 42v600q0 24-18 42t-42 18H570Zm-390 0q-24 0-42-18t-18-42v-600q0-24 18-42t42-18h210q24 0 42 18t18 42v600q0 24-18 42t-42 18H180Zm0-660v600h210v-600H180Zm210 600H180h210Z" })
});
export default SvgSplitscreenRight;
